const LIVE_HOSTS = ['tilkiotomasyon.com', 'www.tilkiotomasyon.com'];

export function isTrackingEnabled() {
  return (
    import.meta.env.PROD &&
    typeof window !== 'undefined' &&
    window.location.protocol === 'https:' &&
    LIVE_HOSTS.includes(window.location.hostname)
  );
}

if (isTrackingEnabled()) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', 'G-H0FP7HFC2E');
  window.gtag('config', 'AW-18351073049');

  const google = document.createElement('script');
  google.async = true;
  google.src = 'https://www.googletagmanager.com/gtag/js?id=G-H0FP7HFC2E';
  document.head.appendChild(google);

  const umami = document.createElement('script');
  umami.defer = true;
  umami.src = 'https://analytics.tilkiotomasyon.com/script.js';
  umami.dataset.websiteId = '1be45cb1-8fb8-44ec-819d-ad18b686c6bd';
  document.head.appendChild(umami);
}
